import { defineMessages } from 'react-intl';

export default defineMessages({
  close: {
    defaultMessage: 'Close',
  },
  message: {
    defaultMessage:
      'If you booked an appointment before the move to permanent daylight savings time on November 1st, your calendar app or confirmation email may not show the correct time. <b>Go to My Appointments to view the correct appointment times.</b>',
  },
  title: {
    defaultMessage: 'Check upcoming appointment times',
  },
});
